import { useState } from 'react'

/** Returns today's date as YYYY-MM-DD (local calendar date). */
export function todayIso(): string {
  return new Date().toISOString().slice(0, 10)
}

/**
 * Shared state hook for the currently selected date.
 * Defaults to today and exposes a stable `today` reference for comparison.
 */
export function useDateState() {
  const today = todayIso()
  const [date, setDate] = useState(today)
  return { date, setDate, today }
}
